<template>
    <!-- Modal Side -->
    <modal-side-generic
    :headerColor="detailHeaderParams.color"
    :title="payloadDetailModal.numbAmortization"
    :subTitle="headerSubTitle"
    :icon="getMobileAppState ? null : detailHeaderParams.bigIcon"
    :triggerClose="triggerClose"
    @hideMe="[triggerClose = false, emit('closeMe')]">
        <div v-for="(lineGroup, index) in detailsArray" :key="`lineGroup${lineGroup.index}`" class="group-wrapper">
            <divider-generic
            dividerSize="medium"
            :icon="lineGroup.icon"
            :title="lineGroup.label"
            :applyBorder="index !== 0"/>
            <!-- Text Block for each line -->
            <text-block-generic
            v-for="(line, index) in lineGroup.lines"
            :key="`lineGroupLine${line,index}`"
            :params="line"
            :icon="line.icon"
            :colorIcon="line.colorIcon"
            applyEllipsis/>
        </div>
    </modal-side-generic>
</template>

<script setup>
import ModalSideGeneric from '@/components/generic/modals/side/Generic'
import DividerGeneric from '@/components/generic/dividers/Generic'
import TextBlockGeneric from '@/components/generic/textBlocks/Generic'

/* Vue */
import { ref, computed } from 'vue'

/* Store */
import { mapGetters } from '@/store/helpers/mappers'

/* i18n */
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

/* mapGetters */
const { getMobileAppState } = mapGetters()

/* Emmitters */
const emit = defineEmits(['closeMe'])

/* Props received:
@detailHeaderParams { Object }
@payloadDetailModal { Object }
*/
const props = defineProps({
    detailHeaderParams: Object,
    payloadDetailModal: Object
})

/* Data */
const triggerClose = ref(false)

const headerSubTitle = computed(() => {
    return props.payloadDetailModal.valueAmortizationRent !== 0 ? props.payloadDetailModal.amount : null
})

const detailsArray = computed(() => {
    return [
        /* Amount Group */
        {
            label: t('credits.myCredits.installments.modals.detail.amountTitle'),
            icon: 'bills',
            lines: [{
                label: t('credits.myCredits.installments.modals.detail.amountLabel'),
                content: props.payloadDetailModal.amount
            }]
        },
        /* Date Blocks */
        {
            label: t('credits.myCredits.installments.modals.detail.dateTitle'),
            icon: 'calendar',
            lines: [{
                label: props.payloadDetailModal.situation.code === 'L' ? t('credits.myCredits.installments.modals.detail.dateLabel') : t('credits.myCredits.installments.modals.detail.dateTitle'),
                content: props.payloadDetailModal.date,
                classes: 'capitalize'
            }]
        },
        /* More Informations Blocks */
        {
            label: t('credits.myCredits.installments.modals.detail.moreInformationsTitle'),
            icon: 'info',
            lines: [{
                label: t('credits.myCredits.installments.modals.detail.numbAmortization'),
                content: props.payloadDetailModal.numbAmortization
            }, {
                label: t('credits.myCredits.installments.modals.detail.situationLabel'),
                content: props.payloadDetailModal.situation.content,
                icon: props.payloadDetailModal.situation.icon,
                colorIcon: props.payloadDetailModal.situation.color
            }, {
                label: t('credits.myCredits.installments.modals.detail.capital'),
                content: props.payloadDetailModal.capital
            }, {
                label: t('credits.myCredits.installments.modals.detail.interestLabel'),
                content: props.payloadDetailModal.interestValue
            }, {
                label: t('credits.myCredits.installments.modals.detail.expensesLabel'),
                content: props.payloadDetailModal.expenses
            }, {
                label: t('credits.myCredits.installments.modals.detail.TAN'),
                content: props.payloadDetailModal.tan + ' %'
            }, {
                label: t('credits.myCredits.installments.modals.detail.capitalDebt'),
                content: props.payloadDetailModal.capitalDebt
            }]
        }
    ]
})

</script>
